export default {
  home: {
    hero: {
      badge: "Hub de ressources shopping 2026",
      title: "Votre ressource complète Basetao Spreadsheet",
      subtitle:
        "Trouvez des feuilles de calcul Basetao utiles, des liens produits, des guides de vendeurs, des conseils QC et de l'aide pour l'expédition — le tout organisé au même endroit.",
      trust: "Ressource d'information indépendante pour les acheteurs Basetao.",
      categoryLabel: "Parcourir par catégorie",
      categoryPlaceholder: "Choisissez une catégorie…",
    },
    categories: {
      title: "Acheter par catégorie",
      subtitle: "Accédez directement aux produits que vous voulez sur le site principal.",
    },
    intro: {
      eyebrow: "Qu'est-ce que c'est",
      title: "Qu'est-ce qu'une feuille de calcul Basetao ?",
      p1: "Une feuille de calcul Basetao est un document organisé qui vous aide à suivre chaque produit, vendeur, prix et détail QC pendant vos achats via l'agent Basetao.",
      p2: "Elle regroupe vos liens, tailles, couleurs et l'avancement de l'expédition au même endroit, pour ne jamais perdre le fil d'une commande ni dépenser trop par accident.",
    },
    features: {
      title: "Tout ce qu'il faut pour acheter plus intelligemment",
      subtitle: "Des liens produits à la livraison finale, restez organisé à chaque étape.",
      items: [
        {
          title: "Catégories sélectionnées",
          desc: "Parcourez 14 catégories de produits et accédez directement à ce que vous voulez.",
        },
        {
          title: "Guides de vendeurs",
          desc: "Comprenez comment comparer les boutiques et choisir des vendeurs de confiance.",
        },
        {
          title: "Conseils QC",
          desc: "Sachez quoi vérifier avant que vos articles quittent l'entrepôt.",
        },
        {
          title: "Aide à l'expédition",
          desc: "Familiarisez-vous avec les méthodes d'expédition et les bases des coûts.",
        },
      ],
    },
    articleTeaser: {
      eyebrow: "Guide en vedette",
      title: "Le guide complet Basetao Spreadsheet",
      desc: "Apprenez à créer et utiliser une feuille de calcul Basetao pour organiser les liens produits, les vendeurs, les photos QC et les détails d'expédition.",
      readMore: "Lire le guide complet",
    },
    faq: {
      title: "Questions fréquentes",
      items: [
        {
          q: "Qu'est-ce que Basetao Spreadsheet ?",
          a: "C'est une ressource d'information qui organise les liens produits, les catégories et les guides d'achat pour aider les acheteurs Basetao à trouver plus vite ce dont ils ont besoin.",
        },
        {
          q: "Vendez-vous des produits directement ?",
          a: "Non. Nous renvoyons vers le site principal où vous pouvez parcourir et acheter les produits.",
        },
        {
          q: "Est-ce le site officiel Basetao ?",
          a: "Non. C'est une ressource d'information indépendante et ce n'est pas le site officiel Basetao, sauf indication contraire explicite.",
        },
        {
          q: "Comment utiliser la liste déroulante des catégories ?",
          a: "Ouvrez la liste, choisissez une catégorie et vous serez dirigé vers la page correspondante sur le site principal.",
        },
      ],
    },
    finalCta: {
      title: "Prêt à explorer les ressources Basetao Spreadsheet ?",
      subtitle: "Parcourez les catégories ci-dessous ou visitez le site principal pour commencer vos achats.",
    },
  },
};